import "bootstrap/dist/css/bootstrap.min.css";
import "./header.css";

import Button from "react-bootstrap/Button"; // Import Button from React-Bootstrap
import Container from "react-bootstrap/Container";
import Badge from "react-bootstrap/Badge"; // Import Badge from React-Bootstrap

//Lgoos
// import { ReactComponent as Logo } from "../../imgs/logo.svg"; // Source: https://iconoir.com/docs/introduction
import ipcLogoWithText from "../../imgs/ipc_logo_with_text.png";
import oxLogo from "../../imgs/ox-logo.png";
import ndmLogo from "../../imgs/ndm_logo.png";
import bdiLogo from "../../imgs/bdi_logo.jpg"; 
import mmmLogo from "../../imgs/mmm_logo.png"; 

import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import ProgressBar from "react-bootstrap/ProgressBar";
import React, { useEffect, useState, useRef } from "react";
import Spinner from "react-bootstrap/Spinner";
import { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { surveyActions } from "../../actions/SurveyActions";
import { useApi } from "../../contexts/ApiProvider";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";
import { useUser } from "../../contexts/UserProvider";

import { TutorialModal } from "../IntroPage/Tutorial";
import { ParticipationInfoModal } from "../PreSurvey/ParticipationInfoModal";

export default function Header() {
  const api = useApi();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  //const { user, logout } = useUser();
  var viewedPts = useSelector((state) => state.patient.viewHistory);
  var surveyedPts = useSelector((state) => state.survey.surveyHistory);
  var surveyedNames = useSelector((state) => state.survey.names);
  var debugSurveyMode = useSelector((state) => state.survey.debug_survey_mode);
  const activeCase = useSelector((state) => state.survey.activeCase);
  const { user, logout, save, isAdmin, reset } = useUser();
  const { handleShowSurvey, debug_mode, changeDebug } = useSurveyMode();
  const totalPatients = 50;

  const containerRef = useRef(null);
  const [showLogos, setShowLogos] = useState(true);
  const [showParticipationInfoModal, setShowParticipationInfoModal] = useState(false);
  const [showTutorialModal, setShowTutorialModal] = useState(false);
  const [showStepper, setShowStepper] = useState(true);
  const [showEvalText, setShowEvalText] = useState(true);
  const [isDownloadingResponses, setIsDownloadingResponses] = useState(false);

  useEffect(() => {
    function updateVisibility() {
      if (containerRef.current) {
        const availableWidth = containerRef.current.clientWidth;
        setShowLogos(availableWidth > 1350);
        setShowStepper(availableWidth > 1230); // <= adjust this cutoff if needed
        setShowEvalText(availableWidth > 1100); // <= adjust this cutoff if needed
      }
    }

    updateVisibility();
    window.addEventListener("resize", updateVisibility);
    return () => window.removeEventListener("resize", updateVisibility);
  }, []);

  // const surveyedPatientsArray = Object.entries(surveyedPts).map(
  //   ([micro_id, details]) => ({
  //     micro_id,
  //     ...details,
  //   })
  // );

  // // console.log('survey_mode', survey_mode);

  // const surveyedFraction =
  //   surveyedPatientsArray.filter((patient) => patient.mode >= 4).length /
  //   totalPatients;

  const switchDebugMode = (mode) => {
    //TODO
  };

  const changeSurveyMode = (mode) => {  
    dispatch(surveyActions.storeDebugSurveyMode(mode));
  };

  const isOnActiveCase =
    activeCase &&
    location.pathname === `/patient/${activeCase.micro_id}`;

  const isViewingPatient = 
    location.pathname.includes("/patient/");

  const activeCaseMode = activeCase
    ? surveyedPts[activeCase.micro_id]?.mode || 0
    : 0;
  const isSurveyCompleted = activeCaseMode >= 4;

  const handleReturnToCase = () => {
    if (activeCase) {
      // Navigate back to the micro_id route
      navigate(`/patient/${activeCase.micro_id}`);
    }
  };

  ///// Phase Progress Bar (stepper) /////
  const existing = activeCase ? surveyedPts[activeCase.micro_id] : null;
  const mode = existing?.mode ?? 0;

  const completed_color = "#06d6a0";
  const not_started_color = "lightgray";
  const in_progress_striped = `repeating-linear-gradient(
    305deg,
    #ffd166 0,
    #ffd166 6px,
    #ffb703 6px,
    #ffb703 10px
  )`;

  let topLabel = "";
  if (mode === 0) {
    topLabel = "Not Started";
  } else if (mode >= 4) {
    topLabel = "Completed";
  }

  function getStepBackground(stepNumber) {
    if (mode === 0) return not_started_color;
    if (mode >= 4) return completed_color;
    if (mode > stepNumber) return completed_color;
    if (mode === stepNumber) return in_progress_striped;
    return not_started_color;
  }

  const step1Background = getStepBackground(1);
  const step2Background = getStepBackground(2);
  const step3Background = getStepBackground(3);

  const stepper = (
    <div style={{ marginRight: "1rem" }}>
      <div style={{ display: "flex", gap: "8px", marginTop: "0px", width: "250px" }}>
        {/* Step 1 */}
        <div style={{ textAlign: "left", flex: 1 }}>
          <div
            style={{
              background: step1Background,
              color: "#000",
              height: "10px",
              width: "100%",
              borderRadius: "4px",
            }}
          />
          {!topLabel && mode === 1 && (
            <div style={{ marginLeft: "2px", marginTop: "0px", marginBottom: "-4px", fontSize: "0.8rem" }}>
              Phase 1
            </div>
          )}
        </div>

        {/* Step 2 */}
        <div style={{ textAlign: "left", flex: 1 }}>
          <div
            style={{
              background: step2Background,
              color: "#000",
              height: "10px",
              width: "100%",
              borderRadius: "4px",
            }}
          />
          {!topLabel && mode === 2 && (
            <div style={{ marginLeft: "2px", marginTop: "0px", marginBottom: "-4px", fontSize: "0.8rem" }}>
              Phase 2
            </div>
          )}
        </div>

        {/* Step 3 */}
        <div style={{ textAlign: "left", flex: 1 }}>
          <div
            style={{
              background: step3Background,
              color: "#000",
              height: "10px",
              width: "100%",
              borderRadius: "4px",
            }}
          />
          {!topLabel && mode === 3 && (
            <div style={{ marginLeft: "2px", marginTop: "0px", marginBottom: "-4px", fontSize: "0.8rem" }}>
              Phase 3
            </div>
          )}
        </div>
      </div>
    </div>
  );

  /// Show the tutorial automatically when flagged by pre-survey
  useEffect(() => {
    const shouldShow = sessionStorage.getItem("showTutorialOnNextPage");
    console.log("shouldShow", shouldShow);
    if (shouldShow === "true") {
      console.log("Showing tutorial modal due to session flag");
      setShowTutorialModal(true);
      sessionStorage.removeItem("showTutorialOnNextPage");
    }
  }, [location.pathname]);

  const handleDownloadAllResponses = async () => {
    if (!isAdmin || isDownloadingResponses) return;

    setIsDownloadingResponses(true);
    try {
      const res = await api.get("/responses");
      if (!res.ok) {
        console.error("Failed to fetch all user responses", res);
        window.alert("Unable to download responses right now. Please try again.");
        return;
      }

      const rows = Array.isArray(res.body) ? res.body : [];
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      const filename = `all_responses_${timestamp}.json`;

      const blob = new Blob([JSON.stringify(rows, null, 2)], {
        type: "application/json",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading all user responses", error);
      window.alert("Unable to download responses right now. Please try again.");
    } finally {
      setIsDownloadingResponses(false);
    }
  };


  return (
    <Navbar bg="light" sticky="top" className="Header" ref={containerRef}>
      <Container className="header-bar">
        <Navbar.Brand
            as={NavLink}
            to={"explore"}
            style={{ display: "inline-flex", marginBottom: "-5px" }}
          >
            <img
              src={ipcLogoWithText}
              alt="MMM Logo"
              style={{ height: "55px", marginLeft: "-10px", marginRight: "10px", marginTop: "-7px", marginBottom: "-5px" }}
            />
            {/* <Logo style={{ marginRight: "10px" }} />
            Infection Prevention and Control Dashboard */}
          {showLogos && (
            <div className="header-logos">
              <img src={oxLogo} alt="Ox Logo" style={{ height: "45px", marginRight: "10px" }} />
              <img src={bdiLogo} alt="BDI Logo" style={{ height: "45px", marginRight: "10px" }} />
              <img src={mmmLogo} alt="MMM Logo" style={{ height: "45px", marginRight: "10px" }} />
            </div>
          )}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          {/* LEFT NAV: Patient List, debug dropdowns, and (optionally) progress bar */}
          {user && (
            <Nav className="me-auto align-items-center flex-nowrap">
              <div class="headerDivider d-none d-lg-block"></div>
              <Nav.Link as={NavLink} to="/explore" style={{ fontSize: "14px" }}>
                Case list
              </Nav.Link>
              {debug_mode && !isViewingPatient && (
                <Nav.Link as={NavLink} to="/prior" style={{ fontSize: "14px" }}>
                  Pre-survey
                </Nav.Link>
              )}
              {!isViewingPatient && (
                <>
                  <Badge pill bg="" className="align-items-center" style={{marginTop: "8px", marginBottom: "5px", marginLeft: "10px", marginRight: "10px", fontSize: 14, fontWeight: 400, pointerEvents: "none", backgroundColor: "#1ABC9C"}}>All progress saved ✓</Badge>
                  <div class="headerDivider d-none d-lg-block"></div>
                  <Nav.Link onClick={() => setShowParticipationInfoModal(true)} className="d-none d-lg-block" style={{ fontSize: "14px" }}>
                    PIS/Consent
                  </Nav.Link>
                  <Nav.Link onClick={() => setShowTutorialModal(true)} className="d-none d-lg-block" style={{ fontSize: "14px" }}>
                    Tutorial
                  </Nav.Link>
                  <Nav.Link onClick={logout} className="d-none d-lg-block" style={{ fontSize: "14px" }}>
                    Save & logout
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/final" className="d-none d-lg-block" style={{ fontSize: "14px" }}>
                    Complete study
                  </Nav.Link>
                  {/* NEW: “More” dropdown appears below lg with those items */}
                  <NavDropdown
                    title="More"
                    id="more-nav-dropdown"
                    className="d-lg-none"
                    align="start"
                    style={{ fontSize: "14px" }}
                    renderMenuOnMount
                  >
                    <NavDropdown.Item onClick={() => setShowParticipationInfoModal(true)}>
                      PIS/Consent
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => setShowTutorialModal(true)}>
                      Tutorial
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={logout}>Save &amp; logout</NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/final">
                      Complete study
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              )}
              {debug_mode && (
                <NavDropdown title="Viewed patients" id="basic-nav-dropdown" style={{ fontSize: "14px" }}>
                  {viewedPts.map((item) => (
                    <NavDropdown.Item
                      as={NavLink}
                      to={`/patient/${item.micro_id}`}
                      key={`${item.micro_id}`}
                    >
                      {item.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              )}
              {debug_mode && (
                <NavDropdown title={`Survey Mode [Debug]`} id="survey-mode-debug-dropdown" style={{ fontSize: "14px" }}>
                  <NavDropdown.Item
                    onClick={() => changeSurveyMode(1)}
                    active={debugSurveyMode === 1}
                  >
                    Phase 1
                  </NavDropdown.Item>
                  <NavDropdown.Item 
                    onClick={() => changeSurveyMode(2)}
                    active={debugSurveyMode === 2}
                  >
                    Phase 2
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => changeSurveyMode(3)}
                    active={debugSurveyMode === 3}
                  >
                    Phase 3
                  </NavDropdown.Item>
                </NavDropdown>
              )}
              {/* Phase bar */}
              {showStepper && (
                <div className="d-flex align-items-center me-2" style={{ paddingTop: "10px", paddingLeft: "20px"}}>
                  {activeCase && isOnActiveCase && !isSurveyCompleted && showStepper && stepper}
                </div>
              )}
              {!showStepper && activeCase && isOnActiveCase && !isSurveyCompleted && (
                <div style={{ fontSize: "14px", marginRight: "1rem", marginLeft: "10px"}}>
                  <Badge pill bg="" className="align-items-center" style={{marginTop: "8px", marginBottom: "5px", marginLeft: "10px", marginRight: "10px", fontSize: 14, fontWeight: 400, pointerEvents: "none", backgroundColor: "#ffb703"}}>
                    {mode === 0 ? "Not started" : mode === 1 ? "Phase 1" : mode === 2 ? "Phase 2" : mode === 3 ? "Phase 3" : "Completed"}
                  </Badge>
                </div>
              )}
            </Nav>
          )}

          {/* RIGHT NAV: The infection history button (moved here) and user dropdown */}
          <Nav>
            {user === undefined ? (
              <Spinner animation="border" />
            ) : (
              <>
                <div>
                  {/* <div style={{maxWidth: "350px", display: "inline-flex", flexDirection: "column", marginRight: "10px", verticalAlign: "middle", textAlign: "right", marginTop: "0px", marginBottom: "0px", fontSize: "10px", color: "#505050"}}>
                    <span style={{fontSize: 11, marginBottom: "2px"}}>Evaluation of an infection prevention and control (IPC) dashboard to track and interrupt spread of healthcare-associated infections</span>
                    <span style={{fontSize: 11, fontWeight: 500}}>MS IDREC Ethics Approval Reference: R68584/RE001</span>
                  </div> */}
                </div>
                {user !== null && (
                  <div>
                    <NavDropdown
                      title={
                        <span style={{ fontSize: 14 }}>
                          &#x1F464; {isAdmin ? user.username + " (Admin)" : user.username}
                        </span>
                      }
                    >
                      <NavDropdown.Item onClick={save}>Save</NavDropdown.Item>
                      {isAdmin && !debug_mode && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Item onClick={() => changeDebug(true)}>
                            <span style={{ color: "red" }}>Switch to debug mode</span>
                          </NavDropdown.Item>
                        </>
                      )}
                      {isAdmin && debug_mode && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Item onClick={() => changeDebug(false)}>
                            <span style={{ color: "red" }}>Switch to survey mode</span>
                          </NavDropdown.Item>
                        </>
                      )}
                      {isAdmin && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Item onClick={reset}>
                            <span style={{ color: "red" }}>Reset</span>
                          </NavDropdown.Item>
                        </>
                      )}
                      {isAdmin && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Item as={NavLink} to={"/register"}>
                            <span style={{ color: "red" }}>Register New User</span>
                          </NavDropdown.Item>
                          <NavDropdown.Divider />
                          <NavDropdown.Item onClick={handleDownloadAllResponses}>
                            <span style={{ color: "red" }}>
                              {isDownloadingResponses
                                ? "Downloading Responses..."
                                : "Download All Responses"}
                            </span>
                          </NavDropdown.Item>
                        </>
                      )}
                      <NavDropdown.Divider />

                      <NavDropdown.Item as={NavLink} to={"/profile"}>
                        Profile
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
                    </NavDropdown>
                  </div>
                )}
                {/* Show the button if we have a user, not in debug mode, and we're on a patient */}
                {user !== null && !debug_mode && isViewingPatient && (
                  <>
                    <div class="headerDivider"></div>
                    <Nav.Item className="d-flex align-items-center me-2" style={{ paddingLeft: "10px" }}>
                      {activeCase && !isOnActiveCase ? (
                        <Button
                          className="call-to-action-danger"
                          variant="danger"
                          onClick={handleReturnToCase}
                          style={{ fontSize: "16px", paddingTop: "5px", paddingBottom: "5px", paddingLeft: "20px", paddingRight: "20px" }}
                        >
                          {showEvalText && (
                            <>⏎ Return to Case {activeCase.case_id}: {activeCase.patient_name} ({activeCase.patient_mrn})</>
                          )}
                          {!showEvalText && <>⏎ Return</>}

                        </Button>
                      ) : activeCase && isOnActiveCase && isSurveyCompleted ? (
                        <Button className="call-to-action" variant="secondary" disabled style={{ fontSize: "16px", paddingTop: "5px", paddingBottom: "5px", paddingLeft: "20px", paddingRight: "20px"}}>
                          Survey Completed
                        </Button>
                      ) : (
                        <Button
                          className="call-to-action"
                          variant="primary"
                          onClick={handleShowSurvey}
                          style={{ fontSize: "16px", fontWeight: 550, paddingTop: "5px", paddingBottom: "5px", paddingLeft: "20px", paddingRight: "20px" }}
                        >
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="white"
                            viewBox="0 0 20 20"
                            style={{ marginRight: "8px" }}
                          >
                            <path d="M10 1.5H6a.5.5 0 0 0-.5.5v1H5A1.5 1.5 0 0 0 3.5 4.5v9A1.5 1.5 0 0 0 5 15h6a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 11 3h-.5v-1a.5.5 0 0 0-.5-.5zm-3 .5h2v1H7v-1zM5 5h6a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 5 5zm1 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6zm0 2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H6z"/>
                          </svg> */}
                          {showEvalText && "Infection History Evaluation ⮕"}
                          {!showEvalText && "Evaluation ⮕"}
                          
                        </Button>
                      )}
                    </Nav.Item>
                  </>
                )}
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
      <ParticipationInfoModal
        showModal={showParticipationInfoModal}
        setShowModal={setShowParticipationInfoModal}
      />
      <TutorialModal
        showModal={showTutorialModal}
        setShowModal={setShowTutorialModal}
      />
    </Navbar>
  );
}
